import getIconFillOrOutlineStyles from '../../getIconFillOrOutlineStyles';
var dropdownSelectedItemStyles = {
  root: function root(_ref) {
    var v = _ref.variables;
    return Object.assign({
      margin: '.4rem 0 0 .4rem',
      color: v.selectedItemColor
    }, v.selectedItemBackgroundColor && {
      backgroundColor: v.selectedItemBackgroundColor
    }, {
      ':focus': {
        color: v.selectedItemColorFocus,
        backgroundColor: v.selectedItemBackgroundColorFocus,
        outline: '0'
      },
      ':hover': {
        color: v.selectedItemColorFocus,
        backgroundColor: v.selectedItemBackgroundColorFocus
      }
    });
  },
  icon: function icon(_ref2) {
    var v = _ref2.variables;
    return Object.assign({}, getIconFillOrOutlineStyles({
      outline: true
    }), {
      ':hover': Object.assign({
        color: v.selectedItemColorFocus
      }, getIconFillOrOutlineStyles({
        outline: false
      }))
    });
  }
};
export default dropdownSelectedItemStyles;